<ng-content></ng-content>
@if (mode?.(); as mode) {
  <span class="form-page-heading__mode-label">{{ mode | translate }}</span>
}
